import { render } from "./CreateWithdrawal.vue?vue&type=template&id=4aa11c2f&ts=true"
import script from "./CreateWithdrawal.vue?vue&type=script&lang=ts"
export * from "./CreateWithdrawal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__